import { useTranslation } from "react-i18next";

export default function MissionVision() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-10">
      <div className="container px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Mission & Vision */}
          <div className="flex flex-col gap-9">
            {/* Our Mission */}
            <div className="flex flex-col gap-4">
              <h2 className="font-semibold text-[#030201] text-3xl sm:text-4xl lg:text-[50px] !leading-tight tracking-tight">
                {t("aboutMissionVision.mission.title")}
              </h2>
              <p className="text-[#44464B] text-base sm:text-lg leading-relaxed font-['IBM_Plex_Sans','IBM_Plex_Sans_Arabic',sans-serif]">
                {t("aboutMissionVision.mission.description")}
              </p>
            </div>

            {/* Our Vision */}
            <div className="flex flex-col gap-4">
              <h2 className="font-semibold text-[#030201] text-3xl sm:text-4xl lg:text-[50px] !leading-tight tracking-tight">
                {t("aboutMissionVision.vision.title")}
              </h2>
              <p className="text-[#44464B] text-base sm:text-lg leading-relaxed font-['IBM_Plex_Sans','IBM_Plex_Sans_Arabic',sans-serif]">
                {t("aboutMissionVision.vision.description")}
              </p>
            </div>
          </div>

          {/* Right Column - Our Story */}
          <div className="flex flex-col gap-6">
            <h2 className="font-semibold text-[#030201] text-3xl sm:text-4xl lg:text-[50px] !leading-tight tracking-tight">
              {t("aboutMissionVision.story.title")}
            </h2>
            <p className="text-[#44464B] text-base sm:text-lg leading-relaxed font-['IBM_Plex_Sans','IBM_Plex_Sans_Arabic',sans-serif]">
              {t("aboutMissionVision.story.paragraph1")}
            </p>
            <p className="text-[#44464B] text-base sm:text-lg leading-relaxed font-['IBM_Plex_Sans','IBM_Plex_Sans_Arabic',sans-serif]">
              {t("aboutMissionVision.story.paragraph2")}
            </p>
            <p className="text-[#44464B] text-base sm:text-lg leading-relaxed font-['IBM_Plex_Sans','IBM_Plex_Sans_Arabic',sans-serif]">
              {t("aboutMissionVision.story.paragraph3")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
